/**
 * ============================================================
 * CURRENCY INPUT COMPONENT
 * ============================================================
 * Input formatado para valores em moeda (R$)
 * Autor: Sistema Pagmus
 * Data: 2025-11-06
 * ============================================================
 */

import React from 'react';
import { Form } from 'react-bootstrap';

const CurrencyInput = ({ value, onChange, placeholder = 'R$ 0,00', ...props }) => {
  const formatCurrency = (val) => {
    // Converte para centavos
    const cents = Math.round((val || 0) * 100);
    const amount = cents / 100;
    
    // Formata para moeda brasileira
    return amount.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const handleChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, '');
    const numericValue = rawValue === '' ? 0 : parseFloat(rawValue) / 100;
    onChange(numericValue);
  };

  return (
    <Form.Control
      type="text"
      value={formatCurrency(value)}
      onChange={handleChange}
      placeholder={placeholder}
      {...props}
    />
  );
};

export default CurrencyInput;

